/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',[
        'SolitaireShared/KlondikeLogic/KlondikeAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/MoveState'
    ],
    function (KlondikeAuthority, IDailyAuthority, CardOp, MoveState) {

        var IDailyKlondikeAuthority = function () {
            this.initIDailyKlondikeAuthority();
        };

        IDailyKlondikeAuthority.constructor = IDailyKlondikeAuthority;
        IDailyKlondikeAuthority.prototype = Object.create(KlondikeAuthority.prototype);
        IDailyAuthority.call(IDailyKlondikeAuthority.prototype);

        IDailyKlondikeAuthority.prototype.initIDailyKlondikeAuthority = function () {
            KlondikeAuthority.call(this);

            this.MovesAllowed = 0;

            this._startingTime = 0;

            this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;

            this.DeckSeeds = [];

            this.IsChallenge = true;

            this.TotalMoves = 0;
        };

        IDailyKlondikeAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer) {
            return 0;
        };

        IDailyKlondikeAuthority.prototype.GetStartingTime = function () {
            return this._startingTime;
        };

        IDailyKlondikeAuthority.prototype.GetScoreForAction = function (action) {
            for (var i = 0; i < action.Ops.length; i++) {
                var op = action.Ops[i];
                if (this.MovesAllowed > 0 && action.GetActionUndoCount() == 0 && op.Opcode != CardOp.Op.Noop && op.Opcode != CardOp.Op.Deal) {
                    action.Tag = (action.Tag | IDailyKlondikeAuthority.TAG_MOVEPERFORMED) >>> 0;
                }
            }

            return KlondikeAuthority.prototype.GetScoreForAction.call(this, action);
        };


        IDailyKlondikeAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
            if (this.MovesAllowed > 0 && !(tag & KlondikeAuthority.TAG_PASSTHROUGHDECK))
                this.TotalMoves += (undo ? -1 : 1);

            KlondikeAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
        };

        IDailyKlondikeAuthority.prototype.IsGameWon = function () {
            return this.IsGameWonPrivate();
        };

        IDailyKlondikeAuthority.prototype.GetIsGameWon = function () {
            return this.IsGameWonPrivate();
        };

        IDailyKlondikeAuthority.prototype.IsGameWonPrivate = function () {
            if (this.MovesAllowed > 0)
                return (KlondikeAuthority.prototype.IsGameWon.call(this) && this.TotalMoves <= this.MovesAllowed + 1);
            return KlondikeAuthority.prototype.IsGameWon.call(this);
        };

        IDailyKlondikeAuthority.prototype.CurrentMoveState = function () {
            if (this.MovesAllowed > 0 && !this.CardSupply.WaitingForAnimation) {
                return this.GetCurrentMoveState();
            }

            return KlondikeAuthority.prototype.CurrentMoveState.call(this);
        };

        IDailyKlondikeAuthority.prototype.GetCurrentMoveState = function () {
            if (this.TotalMoves > this.MovesAllowed + 1)
                return MoveState.NoMovesLeft;
            if (this.TotalMoves == this.MovesAllowed + 1) {
                return (this.IsGameWon() ? MoveState.CanMove : MoveState.NoMovesLeft);
            }
            return KlondikeAuthority.prototype.CurrentMoveState.call(this);
        };

        //#if !CHEATS
        IDailyKlondikeAuthority.prototype.GetHint = function (cycle, cheat) {
            cycle = !!cycle;
            if(!cheat) {
                return new CardOp(this.CardSupply);
            } else {
                return KlondikeAuthority.prototype.GetHint.call(this, cycle, cheat);
            }

        };
        //#endif
        IDailyKlondikeAuthority.prototype.Deal = function () {
            this.TotalMoves = 0;

            if (this.DeckSeeds.length > 0)
                this.CardSupply.DeckSeed = this.DeckSeeds[0];

            return KlondikeAuthority.prototype.Deal.call(this);
        };

        IDailyKlondikeAuthority.prototype.SetDealScript = function (script) {
            this.DealScript = script;
        };

        IDailyKlondikeAuthority.prototype.SetNumBoardsCompleted = function (numBoards) {
        };



        IDailyKlondikeAuthority.TAG_MOVEPERFORMED = 0x40000000;



        Object.defineProperty(IDailyKlondikeAuthority.prototype, "TimerEnabled", {
            get: function () {
                return this._startingTime != 0;
            }
        });

        Object.defineProperty(IDailyKlondikeAuthority.prototype, "StartingTime", {
            get: function () {
                return this._startingTime;
            },
            set: function (value) {
                this._startingTime = value;
                this.CardSupply.IsTimerCountdown = (this._startingTime != 0);
            }
        });


        return IDailyKlondikeAuthority;
    });
